export default __webpack_public_path__ + "static/media/component_tact_switch_2c.1a894fdc.png";